import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { installChunkRecoveryListeners } from '@/app/chunkRecovery';
import { assertRegistryIsValid } from '@/templates';
import '@/styles/globals.css';

assertRegistryIsValid();

// Dynamic imports made outside a component — the PDF renderer, for one — never
// reach the error boundary. Vite's `vite:preloadError` and unhandled rejections
// route those through the same one-shot recovery.
installChunkRecoveryListeners();

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root is missing from index.html.');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
